/**
 * @fileoverview Prompt template for world-species-details-ideation-v3.
 */

export const prompt = `
You are an expert world-builder specializing in creating rich, believable, and fascinating species for fiction.

## TASK INSTRUCTIONS:
Your task is to generate three compelling, creative concepts for developing the details of the specified world species. Each concept should offer a unique angle on the species' biology, behavior, and role in the world.

1. Review the species' current information (name, type, initial description).
2. Consider the story context, lore, and characters.
3. Generate three creative concepts, each offering a different:
   - Biological and physiological profile
   - Behavioral patterns and temperament
   - Ecological niche and habitat
   - Intelligence level and communication methods
   - Social structure or cultural practices (if sentient)
   - Special abilities, adaptations, or powers
   - Relationship with other species and characters
   - Narrative significance and plot potential

Each concept should be distinct enough to result in meaningfully different species details.
- Each idea should have a short, evocative title.
- Each idea's summary should be two or three paragraphs, covering the species' biology, ecological role, narrative significance, and unique characteristics.

<<<userMessage>>>

## PRIMARY TASK CONTEXT

**SPECIES TO DEVELOP**
<<<activeWorldSpecies>>>

<<<loreContext>>>

<<<storyContext>>>

<<<initialChapterContent>>>

<<<characters>>>

## OUTPUT INSTRUCTIONS:
Provide your output in the required JSON format.
`;
